<template>
  <div>
    <AppMenu />

    <BaseBreadcrumb
      :title="$t(title)"
      :help="help"
      :breadcrumbs="breadcrumbs"
      :tutorial="tutorial"
      module="de-credit-note"
    >
      <template v-slot:actions>
        <div class="d-flex justify-end">
          <v-btn
            id="btn-de-credit-note-create"
            class="mr-2"
            v-if="can(moduleActions, 'create')"
            small
            :color="'primary'"
            :title="$t('new')"
            @click="executeCreate()"
          >
            <v-icon small>mdi-plus</v-icon> {{ $t("new") }}
          </v-btn>
        </div>
      </template>
    </BaseBreadcrumb>
    <div class="py-2 mt-4 pl-3 pr-3">
      <v-row no-gutters>
        <v-col cols="12">
          <div class="d-flex flex-column justify-center">
            <Form
              @change:item="updateItemFromResponse"
              :item="item"
              :module-actions="moduleActions"
              ref="form"
              :url-save="urlSave"
              :url-get="urlGet"
            ></Form>
            <v-container fluid class="d-flex flex-column justify-center">
            </v-container>
          </div>
        </v-col>
        <v-col cols="12" md="4" class="px-2"> </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import NextMixinFormPage from "@/components/mixins/NextMixinFormPage";
import Form from "./DeCreditNoteUpdateForm.vue";
import AppMenu from "../menu/AppMenu.vue";

export default {
  mixins: [NextMixinFormPage],
  components: { Form, AppMenu },
  data() {
    return {
      title: "create_de-credit-note",
      urlGet: "api/v1/de-credit-note",
      urlSave: "api/v1/de-credit-note",
      pathBase: "/account/de-credit-note",
      pathCreate: "/account/de-credit-note/create",
      tutorial: {
        default: "https://www.youtube.com/watch?v=0lPTzQWtYow",
        electronic: "https://www.youtube.com/watch?v=0lPTzQWtYow",
      },
    };
  },
  methods: {
    breadcrumbsInit() {
      this.breadcrumbs = [
        {
          text: this.$t("Inicio"),
          disabled: false,
          to: "/admin",
          "exact-path": true,
        },
        {
          text: this.$t("Ventas e Ingresos"),
          disabled: true,
          to: "",
          "exact-path": true,
        },
        {
          text: this.$t("Notas Crédito DE"),
          disabled: true,
          to: "",
          "exact-path": true,
        },
      ];
    },
    itemToTitle() {
      if (this.item.consecutive_credit_note) {
        this.title = "Nota Crédito No " + this.item.consecutive_credit_note;
      }
    },
  },
};
</script>
